import React, { useRef, useEffect } from 'react';
import { useAppStore } from '../../../GlobalStore/GlobalStore';

interface ApiKeyModeWarningProps {}

const ApiKeyModeWarning: React.FC<ApiKeyModeWarningProps> = () => {
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);
    const modalRef = useRef<HTMLDivElement>(null);

    const handleClose = () => {
        setDynamicStateObj({ visiblePopup: null });
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
            handleClose();
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="fixed inset-0 bg-neutral-100/95 dark:bg-neutral-900/95 flex items-center justify-center p-4 z-50">
            <div
                ref={modalRef}
                className="bg-neutral-300 dark:bg-neutral-800/80 rounded-xl shadow-2xl w-[98%] sm:w-11/12 max-w-md overflow-hidden border border-neutral-700/50 relative"
            >
                <button
                    onClick={handleClose}
                    className="absolute top-2 right-2 dark:text-neutral-200 dark:hover:text-white transition-colors duration-200"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>
                </button>
                <div className="p-6">
                    <div className="flex flex-col items-center space-y-4">
                        <div className="h-12 w-12 rounded-full bg-amber-500 flex items-center justify-center">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-8 w-8 text-white"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4.5c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                                />
                            </svg>
                        </div>
                        <h2 className="text-xl font-semibold dark:text-white text-center">
                            Mode Incompatibility
                        </h2>
                        <p className="text-neutral-600 dark:text-neutral-300 text-center">
                            API Key Mode does not work with FSD Mode. FSD mode has been switched to Agent mode.
                        </p>
                        <button
                            onClick={handleClose}
                            className="bg-amber-500 hover:bg-amber-600 text-white font-medium px-6 py-2 rounded-lg transition-colors duration-200"
                        >
                            Got it
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ApiKeyModeWarning;